import React from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

const VideoViewContent = (props) => {
  const { translate, video, isNew, editModal } = props

  return (
    <section>
      <div>
        <div className='text-align-center margin-bottom'>
          <video controls className='margin-top-double'>
            <source src={video.videoUrl} type='video/mp4' />
            {translate('browser.unsupported.video')}
          </video>
        </div>

        <span className='title'>{video.videoTitle}</span>

        <p>{video.videoDescription}</p>
      </div>

      <Row className='margin-top-double margin-bottom'>
        {!isNew && (
          <Col xs={12} md={12}>
            <button
              role='button'
              onClick={() => editModal(video)}
              className='button button-primary button-full align-center'
            >
              {translate('video.edit')}
            </button>
          </Col>
        )}
      </Row>
    </section>
  )
}

VideoViewContent.propTypes = {
  translate: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  editModal: PropTypes.func.isRequired,
  isNew: PropTypes.bool,
  video: PropTypes.object.isRequired,
}

export default VideoViewContent
